export default function Badge({ status = 'offline', label, children }) {
  const variants = {
    online:  'badge-online',
    offline: 'badge-offline',
    alert:   'badge-alert',
    warning: 'badge-warning',
  };
  const dots = { online: '●', offline: '○', alert: '⚠', warning: '!' };

  return (
    <span className={`badge ${variants[status] || 'badge-offline'}`}>
      <span>{dots[status] || '○'}</span>
      {label || children}
    </span>
  );
}
